import React, {useMemo} from 'react';
import {Card} from "../../../../../components/card/card.jsx";
import SentryEchart from "../../../../../components/echarts/sentry-echart.jsx";
import {DASH_BREAKPOINTS, fluidPx} from "../../../../../utils/responsive-graph.js";
import useGraphViewportWidth from "../../../../../hooks/use-graph-viewport-width.js";
import {classNameUtils} from "../../../../../utils/class-name-utils.js";

const customStyle = classNameUtils.cardVariants("customMenu");

const SosHomeHistory = ({data, hasCitizenPermission}) => {
    const vw = useGraphViewportWidth();
    const isCompact = vw < DASH_BREAKPOINTS.desktop;

    const option = useMemo(() => {
        if (!data) return {};

        const labelFs = fluidPx(11, 18, vw);

        const dates = Object.keys(data.sosEventsByDay);
        const values = dates.map(key => data.sosEventsByDay[key]);

        return {
            grid: {top: 16, left: 10, right: 16, bottom: 0, containLabel: true},
            tooltip: {
                trigger: 'axis',
                formatter: (params) => {
                    const [y, m, d] = params[0].axisValue.split('-');
                    const header = `${d}/${m}/${y}`;
                    const lines = params
                        .map(p => `${p.marker} ${p.seriesName}: <b>${p.value}</b>`)
                        .join('<br/>');
                    return `${header}<br/>${lines}`;
                }
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: dates,
                axisLabel: {
                    interval: isCompact ? 1 : 0,
                    lineHeight: labelFs * 1.4,
                    rich: {
                        weekday: {fontSize: labelFs, color: '#676a6c'},
                        date: {fontSize: labelFs, color: '#676a6c'}
                    },
                    formatter: (value) => {
                        const [y, m, d] = value.split('-');
                        const weekday = new Date(+y, +m - 1, +d)
                            .toLocaleDateString('pt-BR', {weekday: 'short'})
                            .replace('.', '')
                            .replace(/^./, c => c.toUpperCase());
                        return `{weekday|${weekday}}\n{date|${d}/${m}}`;
                    }
                },
                axisTick: {show: false},
            },
            yAxis: {
                type: 'value',
                minInterval: 1,
                max: (value) => value.max + 1,
            },
            series: [{
                name: 'SOS',
                type: 'line',
                showSymbol: false,
                itemStyle: {color: '#0080ED'},
                areaStyle: {
                    color: {
                        type: 'linear',
                        x: 0, y: 0, x2: 0, y2: 1,
                        colorStops: [
                            {offset: 0, color: 'rgba(0, 128, 237, 0.4)'},
                            {offset: 1, color: 'rgba(0, 128, 237, 0)'}
                        ]
                    }
                },
                data: values
            }]
        };
    }, [data?.sosEventsByDay, vw])

    return (
        <Card className={"flex flex-col " + (hasCitizenPermission ? "col-span-1" : "col-span-4")}>
            <Card.Header className={customStyle.header}>
                <Card.Title className={customStyle.title}>Histórico de acionamento SOS</Card.Title>
            </Card.Header>
            <Card.Body className={customStyle.bodyBase}>
                <SentryEchart option={option} title={"Últimos 7 dias"} titleClass={"text-[#676a6c]!"}/>
            </Card.Body>
        </Card>
    );
};

export default SosHomeHistory;